import http from "../../http-common";

class NewsArticlesRightSideBooksService {
    getNewsArticlesRightSideBooksService(productPath: string) {
        return http.get(`/right-side-section/news-articles/books?nodeName=${productPath}`);
    }
}

export default new NewsArticlesRightSideBooksService();
